
/* injects from baggage-loader */

'use strict';

import AccountDashboardComponent from './account.dashboard.component';

const AccountDashboardPageModule = angular.module('account-dashboard-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.dashboard', {
        data: {
          title: 'My Account Dashboard',
          navTitle: 'Dashboard'
        },
        url: '',
        component: 'accountDashboard',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          company: function(User, Company) {
            let company = User.current().get('company');
            return Company.get(company.id);
          },
          events: function(Activity) {
            return Activity.fetchSome();
          },
          pendingDocumentRequestsCount: function(DocumentRequest) {
            return DocumentRequest.countPendingRequests();
          },
          user: function(User) {
            return User.refresh();
          }
        },
      });
  })
  .component('accountDashboard', new AccountDashboardComponent());

export default AccountDashboardPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/dashboard/account.dashboard.module.js